/* eslint-disable react/prop-types */
import React, { useState } from "react";
import RefundsTable from "../../components/AllRefundsTable/AllRefundsTable";
import GetAllRefunds from "../../hooks/fetch-hooks/get-all-refunds/get-all-refunds";

function Refunds() {
  const [pageIndex, setPageIndex] = useState(1);
  const [statusSearch, setStatusSearch] = useState("");
  const [appliedStatus, setAppliedStatus] = useState("");
  const pageSize = 50;
  const { data, isLoading } = GetAllRefunds(pageIndex, pageSize, appliedStatus);

  const refundsPayload = data?.data?.data;
  const refunds = Array.isArray(refundsPayload?.refunds)
  ? refundsPayload.refunds
  : [];
  const total = refundsPayload?.total || refunds.length || 0;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));

  return (
    <div className="p-7 h-full overflow-y-scroll bg-gray-50">
      <h2 className="text-2xl font-semibold mb-4">All Refunds</h2>
      <div className="flex gap-3 items-center mb-4">
        <input
          value={statusSearch}
          onChange={(e) => setStatusSearch(e.target.value)}
          placeholder="Search by status..."
          className="px-4 py-2 border rounded-md bg-white"
        />
        <button
          className="px-4 py-2 rounded-md bg-[#00A48B] text-white-50"
          onClick={() => {
            setPageIndex(1);
            setAppliedStatus(statusSearch.trim());
          }}
        >
          Search
        </button>
        <button
          className="px-4 py-2 rounded-md bg-gray-200"
          onClick={() => {
            setStatusSearch("");
            setAppliedStatus("");
            setPageIndex(1);
          }}
        >
          Clear
        </button>
      </div>
      <RefundsTable refunds={refunds} isLoading={isLoading} />
      <div className="btn_div mt-4">
        <button onClick={() => setPageIndex((p) => p - 1)} disabled={pageIndex <= 1} className="previous">
          Previous
        </button>
        <span className="pageindex">{`Page ${pageIndex} of ${totalPages}`}</span>
        <button
          onClick={() => setPageIndex((p) => p + 1)}
          disabled={pageIndex >= totalPages}
          className="next"
        >
          Next
        </button>
      </div>
    </div>
  );
}

export { Refunds };